import * as React from 'react';
import { render } from 'react-dom';

import { AuthButton, IUser, SSOTypes } from '@action/auth-button';
import { ActionAuthButtonExternal, IAuthButtonConfig } from './utils/ActionAuthButtonExternal';

import authButtonStyles from './authButtonStyles.module.css';

// tslint:disable:no-any
const renderApp = (config: IAuthButtonConfig) => {
  const links = config.reglink || config.supportlink
    ? {
      registration: config.reglink,
      supportlink: config.supportlink,
    }
    : undefined;

  const userHandler = (user: IUser) => {
    (window as any).ActionAuthButtonExternal.setUser(user);
    config.onUserChange(user);
  };

  const tokenHandler = (token: string | null) => {
    config.onTokenChange(token);
  };

  render(
    <AuthButton
      styles={authButtonStyles}
      user={config.user}
      appId={config.appid}
      productVersionIds={config.productVersionIds}
      links={links}
      lang={config.lang}
      emid={config.emid}
      theme={config.theme}
      env={config.mode}
      onUserChange={userHandler}
      onTokenChange={tokenHandler}
      ssoType={SSOTypes.SSOExternal}
      text={config.text}
      placement={config.placement}
      feedback={config.feedback}
      setHandler={(window as any).ActionAuthButtonExternal.setHandler}
    />,
    document.getElementById('authButtonExternal'),
  );
};

const createAppContainer = (elementId: string) => {
  if (!elementId) {
    // eslint-disable-next-line no-console
    console.warn('Укажите блок для вставки -> config.loginblock');

    return;
  }

  const container = document.createElement('div');

  container.setAttribute('id', 'authButtonExternal');

  const targetContainer = document.getElementById(elementId);

  if (targetContainer) {
    targetContainer.appendChild(container);
  }
};

const initApp = (config: IAuthButtonConfig) => {
  createAppContainer(config.loginblock);
  renderApp(config);
};

/* ts-lint:disable */
(() => {
  (window as any).ActionAuthButtonExternal = new ActionAuthButtonExternal(initApp);
})();
/* ts-lint:enable */
